"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0; // @ts-check

/**
 * @param {any} comp
 * @returns {object}
 */

var renderComponent = function renderComponent(comp) {
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    throw comp(props);
  };
};

var _default = renderComponent;
exports.default = _default;